<div id="body">
  <button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
  <div class="main" *ngIf="data.length > 0">
    <div *ngFor="let item of data; let i = index;" >
      <span class="name">{{item.coeCommodity}}</span>
      <div [id]="'chart' + i" class="d-flex justify-content-center"></div>
    </div>
  </div>
  <div *ngIf="data.length === 0"> No Data</div>
</div>